<template>
  <v-dialog
    v-model="openDialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="documentDropOffEnabled ? '800' : '600'"
    @keydown.esc="openDialog = false"
  >
    <v-card block flat>
      <v-card-title class="title pb-0">
        <span class="title"
          >New {{ projectViewEnabled ? 'Project' : 'Questionnaire' }} Type</span
        >
      </v-card-title>
      <v-card-text>
        <v-layout column>
          <v-layout justify-center>
            <v-flex
              xs6
              id="new-questionnaire-template-box"
              class="mr-2 send-questionnaire-dialog__block"
              style="cursor: pointer"
              @click="
                openDialog = false;
                $emit('open-send-template-dialog');
              "
            >
              <v-layout column align-center>
                <i class="material-icons-outlined primary--text" size="40">
                  description
                </i>
                <div class="primary--text subheading"><b>Template</b></div>
                <div class="grey--text mt-2" v-if="projectViewEnabled">
                  Set of steps that you've previously customized. You can edit
                  the templates in <b>Project Templates</b> page.
                </div>
                <div class="grey--text mt-2" v-else>
                  List of questions that you've previously customized. You can
                  edit the templates in <b>Questionnaire Templates</b> page.
                </div>
              </v-layout>
            </v-flex>

            <v-flex
              v-if="documentDropOffEnabled"
              xs6
              class="mr-2 send-questionnaire-dialog__block"
              style="cursor: pointer"
              @click="
                openDialog = false;
                $emit('open-send-document-drop-off-dialog');
              "
            >
              <v-layout column align-center>
                <i class="material-icons-outlined primary--text" size="40">
                  inbox
                </i>
                <div class="primary--text subheading">
                  <b>Document Drop Off</b>
                </div>
                <div class="grey--text mt-2">
                  A simple document request using rollover items without signing
                  in
                </div>
              </v-layout>
            </v-flex>

            <v-flex
              xs6
              class="send-questionnaire-dialog__block"
              style="cursor: pointer"
              @click="
                openDialog = false;
                $emit('open-send-open-items-dialog');
              "
            >
              <v-layout column align-center>
                <i class="material-icons-outlined primary--text" size="40">
                  list
                </i>
                <div class="primary--text subheading"><b>Custom</b></div>
                <div class="grey--text mt-2">
                  Custom list of questions and items you need from your clients
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <sx-button-group x-align="right" :is-full-width="true">
          <div @click="openDialog = false">
            <sx-button type="secondary">
              {{ $t('cancel') }}
            </sx-button>
          </div>
        </sx-button-group>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FirmPreferenceMixins from '@/mixins/FirmPreferenceMixins';
import SxButton from '@/components/sx/SxButton';
import SxButtonGroup from '@/components/sx/SxButtonGroup';

export default {
  name: 'sendQuestionnaireDialog',
  components: {
    SxButton,
    SxButtonGroup,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [FirmPreferenceMixins],
  watch: {
    value(newVal) {
      this.openDialog = newVal;
    },
    openDialog(newVal) {
      this.$emit('input', newVal);
    },
  },
  data() {
    return {
      openDialog: false,
    };
  },
  created() {
    this.openDialog = this.value;
  },
};
</script>

<style scoped="true">
.send-questionnaire-dialog__block {
  padding: 24px 16px;

  background-color: var(--gray-25);
  border: 1px solid var(--gray-50) !important;
  border-radius: 4px;
  transition: all 120ms ease-in-out;
}

.send-questionnaire-dialog__block:hover {
  border-color: var(--gray-100) !important;
  background-color: var(--gray-100);
}
</style>
